export default __webpack_public_path__ + "static/media/regreenbus_info_visual_01.7678cde4.png";